import React from "react";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import {Alert, Button, Card, Col, DatePicker, Form, Layout, Row, Select} from "antd";
import {fetchDataEntity} from "../../../api/entity-data";
import {FormatMoneySouthAfrica, SortData, UpcaseFirst,} from "../../../api/fn";
import {PostToPbx} from "../../../api/http-post";
import moment from "moment";
import LoadingProcessing from "../../../components/Common/page/Common/LoadingProcessing";
import DisplayDataReportSummaryHours from "../../../components/Reports/DisplayDataReportSummaryHours";
import Configures from "../../../configures";
import {GetConfigures} from "../../../configures/serve";
import {GetUserToken} from "../../../api/token";
import {loadData} from "../invoices/SetupLabourInvoice/lib";
import TableDataView from "../../../components/Common/tables/TableDataView";
import {Table} from 'antd';
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import '../../../assets/css/payroll-dashboard.css'
import {Colors} from "../../../constants/colors";
import DashboardPayrollLinePolite from "../../../components/Invoicings/Dashboard/DashboardPayrollLinePolite";
import DashChart2 from "../../../components/Invoicings/Dashboard/DashChart2";
import DashChartColumn from "../../../components/Invoicings/Dashboard/DashChartColumn";
import {FindMonthIndexFromShortName} from "../../../api/date-functions";
import DashChartColumn2 from "../../../components/Invoicings/Dashboard/DashChartColumn2";
import {CloseCircleOutlined} from "@ant-design/icons";
import totalBreakDown from "../../../components/Invoicings/Dashboard/TotalBreakDown";

const {Content} = Layout;
const {Option} = Select;

function convertDateFormat_DDMMYYYY(dateIn) {
    let mydate = moment(dateIn, "YYYY-MM-DD").format("DD MMM YYYY");
    return mydate;
}

function formatCurrency(stringIn) {
    return stringIn.toFixed(2)
}

const toShort = (inValue) => {
    let amount = inValue
    try{
        amount = inValue.toFixed(2)
    }catch (e) {
        console.log(":::) err toShort > ",inValue," > ",e)
    }
    return parseFloat(amount)
}
const toShort2 = (inValue) => {
    let amount = inValue.toFixed(0)
    return parseFloat(amount)
}


class DashboardPayrollProfitPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Org: "",
            Companies: [],
            Entities: [],
            FnbCsvInfo: [],

            selectedCompany: "",
            selectedModule: "",
            selectedRecord: {},
            selectedPeriod: "",
            selectedSite: "",

            Data: [],
            isLoading: false,
            component: "list",
            initLoading: false,

            DataPeriod: [],
            DataPayCycle: [],
            DataSite: [],
            DataSavedPayroll: [],

            Results: null,
            showViewDetail: false,
        }

    }
    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.initialReload()
        /**
         * todo delete this after design interface
         */
        //this.defaultData()
    }
    initialReload = async () => {
        await fetchDataEntity("Entities", "", "", this, undefined, "common/entity/modules/list");
        await this.loadSavedPayroll()
    }
    loadSavedPayroll = async () => {
        await this.loadData("PayrollSavedSummaryAll", "DataSavedPayroll")
    }
    defaultData = () => {
        this.setState({
            Results: JSON.parse(`{"Breakdown":{"2022-04":{"Month":"2022-04","Invoices":2171476.21,"PayrollWages":1547072.6,"PayrollEmployees":270},"2022-05":{"Month":"2022-05","Invoices":2158331.35,"PayrollWages":1488461.8,"PayrollEmployees":272},"2022-06":{"Month":"2022-06","Invoices":2464012.4299999997,"PayrollWages":1450994.5,"PayrollEmployees":272},"2022-07":{"Month":"2022-07","Invoices":2173769.11,"PayrollWages":1445480,"PayrollEmployees":273}},"TotalRevenue":8967589.1,"TotalPayroll":5932008.9,"TotalGrossWage":5932008.9,"TotalUif":59320.08900000001,"TotalPaye":649.07,"TotalDeduction":0,"TotalWagesNotClaimed":1564416.4100000001,"TotalNetPay":5872039.9,"TotalGrossProfit":3035580.1999999993,"SummaryAll":[{"AppName":"pmis","Id":"d08b46f1-46e9-4315-a1f2-6b275d58699d","Org":"C100006","Project":"Servicing of 100 Litre Waste Tank in Informal Settlements City Wide","TargetPeriod":"","Year":"2022","StartDate":"2022-04-01","EndDate":"2022-04-30","Month":"04","Employees":270,"GrossWages":1547072.6,"Uif":15470.727,"Paye":234.22,"OtherDeduction":0,"PatientFound":0,"NetWages":1531367.8,"NoComplained":418835.75,"DropboxRev":"5e65478c05c975259b47c","Profile":null,"OrgDateTime":"2022-08-16 04:51:53","Date":"2022-08-16","Time":"04:51:53","Status":"active"},{"AppName":"pmis","Id":"ca10185f-4c82-48e8-bed8-334aebfda053","Org":"C100006","Project":"Servicing of 100 Litre Waste Tank in Informal Settlements City Wide","TargetPeriod":"","Year":"2022","StartDate":"2022-05-01","EndDate":"2022-05-31","Month":"05","Employees":272,"GrossWages":1488461.8,"Uif":14884.617,"Paye":181.89,"OtherDeduction":0,"PatientFound":0,"NetWages":1473395.2,"NoComplained":389656.4,"DropboxRev":"5e65475292b935259b47c","Profile":null,"OrgDateTime":"2022-08-16 04:50:53","Date":"2022-08-16","Time":"04:50:53","Status":"active"},{"AppName":"pmis","Id":"cc84716f-3a46-4e94-b145-fe4578689c48","Org":"C100006","Project":"Servicing of 100 Litre Waste Tank in Informal Settlements City Wide","TargetPeriod":"","Year":"2022","StartDate":"2022-06-01","EndDate":"2022-06-30","Month":"06","Employees":272,"GrossWages":1450994.5,"Uif":14509.945,"Paye":155.73,"OtherDeduction":0,"PatientFound":0,"NetWages":1436328.9,"NoComplained":373382.4,"DropboxRev":"5e654709b799c5259b47c","Profile":null,"OrgDateTime":"2022-08-16 04:49:36","Date":"2022-08-16","Time":"04:49:36","Status":"active"},{"AppName":"pmis","Id":"16b60a32-2f56-4b8d-bf6b-70491e53cc3d","Org":"C100006","Project":"Servicing of 100 Litre Waste Tank in Informal Settlements City Wide","TargetPeriod":"","Year":"2022","StartDate":"2022-07-01","EndDate":"2022-07-30","Month":"07","Employees":273,"GrossWages":1445480,"Uif":14454.8,"Paye":77.23,"OtherDeduction":0,"PatientFound":0,"NetWages":1430948,"NoComplained":382541.84,"DropboxRev":"5e6456481806e5259b47c","Profile":null,"OrgDateTime":"2022-08-15 10:52:26","Date":"2022-08-15","Time":"10:52:26","Status":"active"}],"SummaryDesignations":[{"AppName":"","Id":"","Org":"","Project":"","TargetPeriod":"","Year":"","StartDate":"","EndDate":"","Month":"","Designation":"BQ Supervisor","WageRate":36.34,"ChargeOutRate":0,"Quantity":4,"GrossWages":32706,"Profile":null,"OrgDateTime":"","Date":"","Time":"","Status":""},{"AppName":"","Id":"","Org":"","Project":"","TargetPeriod":"","Year":"","StartDate":"","EndDate":"","Month":"","Designation":"General Worker","WageRate":25.52,"ChargeOutRate":37.1,"Quantity":702,"GrossWages":4033385.03,"Profile":null,"OrgDateTime":"","Date":"","Time":"","Status":""},{"AppName":"","Id":"","Org":"","Project":"","TargetPeriod":"","Year":"","StartDate":"","EndDate":"","Month":"","Designation":"Puller","WageRate":25.52,"ChargeOutRate":0,"Quantity":289,"GrossWages":1326325.45,"Profile":null,"OrgDateTime":"","Date":"","Time":"","Status":""},{"AppName":"","Id":"","Org":"","Project":"","TargetPeriod":"","Year":"","StartDate":"","EndDate":"","Month":"","Designation":"Team Leader","WageRate":27.26,"ChargeOutRate":41.32,"Quantity":56,"GrossWages":334207.6,"Profile":null,"OrgDateTime":"","Date":"","Time":"","Status":""},{"AppName":"","Id":"","Org":"","Project":"","TargetPeriod":"","Year":"","StartDate":"","EndDate":"","Month":"","Designation":"Washer","WageRate":25.52,"ChargeOutRate":0,"Quantity":36,"GrossWages":205384.96000000002,"Profile":null,"OrgDateTime":"","Date":"","Time":"","Status":""}]}`)
        })
    }
    onChangeStartDate = (dateIn, dt) => {
        console.log("onChangeStartDate > ", dt, dateIn)
        this.setState({StartDate: dt})
    }
    onChangeEndDate = (dateIn, dt) => {
        console.log("onChangeEndDate > ", dt, dateIn)
        this.setState({EndDate: dt})
    }

    loadContractInfo = async (selectedModule) => {
        let _this = this;
        let module = this.state.selectedModule;
        let hub = {
            Org: this.state.selectedCompany,
            Module: "contract",
            Ref: selectedModule,
        }

        console.log("loadContractInfo > ", hub)
        let endpoint = "/payroll/contract/fetch-data"
        await PostToPbx(hub, endpoint, async (output) => {
            let data = output.RESULT;
            let tmp = _this.state;
            tmp.DataPeriod = data.TermsPeriod;
            tmp.DataDesignation = data.TermsDesignation;
            tmp.DataPayCycle = data.TermsPayCycle;
            tmp.DataSite = data.TermsSite;
            tmp.DataRate = data.TermsRate;
            tmp.DataRateSpecific = data.TermsRateSpecific;
            tmp.DataSlot = data.TermsSlot;
            tmp.DataSiteDesignation = data.TermsSiteDesignation;
            tmp.DataShift = data.TermsShift;
            tmp.DataCondition = data.TermsCondition;
            _this.setState(tmp);

            console.log("loadInitialData > ", output, " > ", data)
        });
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
            this.setState({
                isLoading: false,
            })
        });
    }
    handleChangeCompany = (value, key) => {
        this.setState({
            [key]: value,
        })
    }
    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        });

        if (key === "selectedModule") {
            console.log("selected module > ", key, value)
            await this.loadContractInfo(value)
        }

    }
    handleChange2 = (e, ee, key) => {
        const val = e;
        let tmp = this.state;
        tmp[key] = val;
        this.setState(tmp);
    }
    validateSubmitSearch = () => {
        const state = this.state;
        if (state.selectedCompany === "") {
            alert("Validation fail! Please select your company")
            return false
        }
        if (state.selectedModule === "") {
            alert("Validation fail! Please select your project")
            return false
        }

        return true
    }
    submitSearch = async () => {
        this.setState({
            isLoading: true,
            Results: null,
        });

        if (!this.validateSubmitSearch()) {
            return
        }

        let hub = {
            Org: this.state.selectedCompany,
            Project: this.state.selectedModule,
            StartDate: this.state.StartDate,
            EndDate: this.state.EndDate
        }

        console.log("1 -Data--> ", hub)
        let endpoint = "/payroll/dashboard/overview"
        await PostToPbx(hub, endpoint, async (output) => {
            let data = output.RESULT;
            this.setState({
                Results: data,
                isLoading: false,
            });
            console.log("-search Data--> ", data)
        });

    }
    renderWarningBar = () => {
        return
        let boo = false
        if (this.state.selectedCompany === "" || this.state.selectedEntity === "" || this.state.component === "form") {
            boo = true
        }
        if (!boo) {
            return
        }
        return (
            <div style={{minWidth: "100%", padding: 10, color: "red"}}>
                <Alert style={{margin: '16px 0'}} message="Please select your company above to view your records!"
                       type={"error"}/>
            </div>
        )
    }
    renderCompaniesSelection = () => {
        if (this.state.component === "form") {
            return
        }
        let ls = this.state.Companies;
        return (
            <Form.Item
                label={""}
                name={"selectedCompany"}
                rules={[{required: true, message: "Please select your company!"}]}
            >
                <Select
                    style={{width: "100%"}}
                    onChange={(value) => this.handleChangeCompany(value, "selectedCompany")}
                    value={this.state.selectedCompany}
                >
                    {ls.map((record, index) => {
                        return (
                            <Option
                                key={record.CustomerNumber}
                                value={record.CustomerNumber}
                            >
                                {record.Name}
                            </Option>
                        )
                    })}
                </Select>
            </Form.Item>

        )
    }
    renderModules = () => {
        let ls = [];
        let org = this.state.selectedCompany;
        for (let i in this.state.Entities) {
            const row = this.state.Entities[i];

            if (row.org === org) {
                ls.push({
                    key: row.name,
                    val: row.name,
                })
            }
        }
        return (
            <Select
                name={"selectedModule"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedModule")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }
    formatDate = (dateIn) => {
        return convertDateFormat_DDMMYYYY(dateIn)
    }
    renderList = () => {

        let columns = [
            {id: 'StartDate', label: 'Start Date', minWidth: 170, dataType: "string"},
            {id: 'EndDate', label: 'End Date', minWidth: 170, dataType: "string"},
            {id: 'PeriodNumber', label: '# Period', minWidth: 170, dataType: "string"},
            {id: 'TargetPeriod', label: 'TargetPeriod', minWidth: 170, dataType: "string"},
            {id: 'Employees', label: 'Employees', minWidth: 170, dataType: "string"},
            {id: 'GrossWages', label: 'GrossWages', minWidth: 170, dataType: "string"},
            {id: 'Uif', label: 'Uif', minWidth: 170, dataType: "string"},
            {id: 'Paye', label: 'Paye', minWidth: 170, dataType: "string"},
            {id: 'OtherDeduction', label: 'Other Dec.', minWidth: 170, dataType: "string"},
            {id: 'NetWages', label: 'NetWages', minWidth: 170, dataType: "string"},
            {id: 'Saved', label: 'Saved', minWidth: 170, dataType: "string"},
        ];

        let ls = this.state.Results;
        let otherFunctions = []

        let data = {columns: columns, data: ls}

        return (
            <TableDataView
                {...data}
                tableTitle={UpcaseFirst(this.state.selectedModule) + " Records  (" + data.data.length + ") "}
                otherFunctions={otherFunctions}
                options={{
                    pageSize: 32,
                    width: "100%"
                }}
            />
        )
    }
    renderPayrollDesignationSummaryTable = () => {
        const Headers = () => {
            return (
                <Row gutter={16} style={{padding: 10}}>
                    <Col span={8} className={"payrollDashTh1 pushLeft"}>Designation</Col>
                    <Col span={4} className={"payrollDashTh1 pushCenter"}>Wage Rate</Col>
                    <Col span={4} className={"payrollDashTh1 pushRight"}>Change Out Rate</Col>
                    <Col span={3} className={"payrollDashTh1 pushCenter"}>Quantity</Col>
                    <Col span={5} className={"payrollDashTh1 pushRight"}>Gross Wages</Col>
                </Row>
            )
        }

        const data = this.state.Results.SummaryDesignations;
        let totGrossWage=0,totQuantity=0;
        let pos = 1;
        return (
            <div style={{backgroundColor: "white"}}>
                <div className={"headerTableContainer"}>
                    <h3 className={"headerTable"}>Wage Payments Peer Employee Desigantion</h3>
                </div>

                {Headers()}
                {data.map(row => {
                    if (pos === 0) {
                        pos = 1
                    } else if (pos === 1) {
                        pos = 0
                    }
                    let classNotClaimed = "";
                    if (row.ChargeOutRate === 0) {
                        classNotClaimed = "notClaimed"
                    }

                    totGrossWage +=row.GrossWages;
                    totQuantity +=row.Quantity;

                    return (
                        <Row gutter={16} style={{marginTop: 10, marginLeft: 10}}>
                            <Col span={8}
                                 className={`payrollDashTd1 pushLeft ${pos === 1 ? "tripper" : ""}`}>{row.Designation}</Col>
                            <Col span={4}
                                 className={`payrollDashTd1 pushRight  ${pos === 1 ? "tripper" : ""}`}>{row.WageRate}</Col>
                            <Col span={4}
                                 className={`payrollDashTd1 pushRight ${pos === 1 ? "tripper" : ""}`}>{row.ChargeOutRate}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushCenter  ${pos === 1 ? "tripper" : ""}`}>{row.Quantity}</Col>
                            <Col span={5}
                                 className={`payrollDashTd1 pushRight ${classNotClaimed} ${pos === 1 ? "tripper" : ""}`}>{FormatMoneySouthAfrica(toShort(row.GrossWages))}</Col>
                        </Row>
                    )
                })}

                <Row gutter={16} style={{padding: 10}}>
                    <Col span={8} className={"payrollDashTh2 pushLeft"}></Col>
                    <Col span={4} className={"payrollDashTh2 pushCenter"}></Col>
                    <Col span={4} className={"payrollDashTh2 pushRight"}></Col>
                    <Col span={3} className={"payrollDashTh2 pushCenter"}>{FormatMoneySouthAfrica(toShort2(totQuantity))}</Col>
                    <Col span={5} className={"payrollDashTh2 pushRight"}>{FormatMoneySouthAfrica(toShort(totGrossWage))}</Col>
                </Row>

            </div>
        )

    }
    renderPayrollByMonthTable = () => {
        const Headers = () => {
            return (
                <Row gutter={16} style={{marginTop: 10, marginLeft: 10}}>
                    <Col span={5} className={"payrollDashTh1 pushLeft"}>Month</Col>
                    <Col span={3} className={"payrollDashTh1 pushCenter"}>Employees</Col>
                    <Col span={3} className={"payrollDashTh1 pushRight"}>Gross wages</Col>
                    <Col span={3} className={"payrollDashTh1 pushRight"}>UIF</Col>
                    <Col span={3} className={"payrollDashTh1 pushRight"}>PAYE</Col>
                    <Col span={3} className={"payrollDashTh1 pushRight"}>O.Deduction</Col>
                    <Col span={3} className={"payrollDashTh1 pushRight"}>Net Pay</Col>
                </Row>
            )
        }
        let totGrossWage=0,totUif=0,totPaye=0,totDeduction=0,totNetPay=0;
        const data = [];
        for (let i in this.state.Results.SummaryAll) {
            let row = this.state.Results.SummaryAll[i];
            row.Month = moment(row.StartDate, 'YYYY-MM-DD').format("MMMM-YYYY")
            data.push(row)
            totGrossWage +=row.GrossWages;
            totUif  +=row.Uif;
            totPaye +=row.Paye;
            totDeduction +=row.OtherDeduction;
            totNetPay +=row.NetWages
        }

        let emptyRow = [];
        let diff = 0;
        if (data.length < 12) {
            diff = 12 - data.length
        }
        for (let i = 0; i < diff; i++) {
            emptyRow.push({
                Month: "",
                Employees: "",
                GrossWages: "",
                Uif: "",
                Paye: "",
                OtherDeduction: "",
                NetWages: ""
            })
        }

        let pos = 1;
        return (
            <div style={{backgroundColor: "white"}}>
                <div className={"headerTableContainer"}>
                    <h3 className={"headerTable"}>Payroll by Month</h3>
                </div>
                {Headers()}
                {data.map(row => {
                    if (pos === 0) {
                        pos = 1
                    } else if (pos === 1) {
                        pos = 0
                    }
                    return (
                        <Row gutter={16} style={{marginTop: 10, marginLeft: 10}}>
                            <Col span={5}
                                 className={`payrollDashTd1 pushLeft ${pos === 1 ? "tripper" : ""}`}>{row.Month}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushCenter ${pos === 1 ? "tripper" : ""}`}>{row.Employees}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushRight ${pos === 1 ? "tripper" : ""}`}>{FormatMoneySouthAfrica(toShort(row.GrossWages))}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushRight ${pos === 1 ? "tripper" : ""}`}>{FormatMoneySouthAfrica(toShort(row.Uif))}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushRight ${pos === 1 ? "tripper" : ""}`}>{FormatMoneySouthAfrica(toShort(row.Paye))}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushRight ${pos === 1 ? "tripper" : ""}`}>{FormatMoneySouthAfrica(toShort(row.OtherDeduction))}</Col>
                            <Col span={3}
                                 className={`payrollDashTd1 pushRight ${pos === 1 ? "tripper" : ""}`}>{FormatMoneySouthAfrica(toShort(row.NetWages))}</Col>
                        </Row>
                    )
                })}

                {emptyRow.map(row => {
                    if (pos === 0) {
                        pos = 1
                    } else if (pos === 1) {
                        pos = 0
                    }
                    return (
                        <Row gutter={16} style={{marginTop: 10, marginLeft: 10}}>
                            <Col span={5} className={`payrollDashTd1 pushLeft `}>&nbsp;</Col>
                            <Col span={3} className={`payrollDashTd1 pushCenter`}>{row.Employees}</Col>
                            <Col span={3} className={`payrollDashTd1`}>{row.GrossWages}</Col>
                            <Col span={3} className={`payrollDashTd1`}>{row.Uif}</Col>
                            <Col span={3} className={`payrollDashTd1`}>{row.Paye}</Col>
                            <Col span={3} className={`payrollDashTd1`}>{row.OtherDeduction}</Col>
                            <Col span={3} className={`payrollDashTd1`}>{row.NetWages}</Col>
                        </Row>
                    )
                })}

                <Row gutter={16} style={{marginTop: 10, marginLeft: 10}}>
                    <Col span={5} className={"payrollDashTh2 pushLeft"}>&nbsp;</Col>
                    <Col span={3} className={"payrollDashTh2 pushCenter"}></Col>
                    <Col span={3} className={"payrollDashTh2"}>{FormatMoneySouthAfrica(toShort(totGrossWage))}</Col>
                    <Col span={3} className={"payrollDashTh2"}>{FormatMoneySouthAfrica(toShort(totUif))}</Col>
                    <Col span={3} className={"payrollDashTh2"}>{FormatMoneySouthAfrica(toShort(totPaye))}</Col>
                    <Col span={3} className={"payrollDashTh2"}>{FormatMoneySouthAfrica(toShort(totDeduction))}</Col>
                    <Col span={3} className={"payrollDashTh2"}>{FormatMoneySouthAfrica(toShort(totNetPay))}</Col>
                </Row>

            </div>
        )


    }

    renderGrossWagePaymentByMonth = () => {
        /**
         let data = [32.32, 28.65, 36.63, 21.25, 42.36];
         let categories = ["Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22"]
         let GrossProfitMarginTarget = 25
         return (
         <DashboardPayrollLinePolite
         avgIn={GrossProfitMarginTarget}
         chartId={"dashTrend1"}
         data={data}
         columnColor={["#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50",]}
         titleChart={"Gross Profit Margin Trend"}
         categories={categories}
         />
         )
         * @type {*[]}
         */
            //{"Breakdown":{"2022-04":{"Month":"2022-04","Invoices":2171476.21,"Payroll":1547072.6}
        let data1 = []
        let data2 = [];
        let data2Categories = [];
        for (let i in this.state.Results.Breakdown) {
            let row = this.state.Results.Breakdown[i]
            let wages = row.PayrollWages;
            let employees = row.PayrollEmployees;
            let invoices = row.Invoices;
            let shortDate = moment(row.Month, "YYYY-MM").format("MMM-YY");
            data1.push({
                name: shortDate, y: wages,
                index: FindMonthIndexFromShortName(i.split("-")[0])
            })
            data2.push(employees)
            data2Categories.push(shortDate)
        }
        return (
            <Row>
                <Col span={12} className={"bb1"}>
                    <DashChartColumn2
                        chartId={"ch02"}
                        titleChart={"Gross Wage Payments by Month"}
                        data={data1}
                        columnColor={["#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50",]}
                        extraClass={"bb1"}
                        tickPositions={[20000,400000,600000,800000,1000000,1200000,1400000,1600000,1800000,2000000]}
                    />
                </Col>
                <Col span={12} className={"bb1"} style={{marginTop: 10}}>
                    <DashboardPayrollLinePolite
                        avgIn={0}
                        chartId={"dashTrend2"}
                        data={data2}
                        columnColor={["#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50",]}
                        titleChart={"Employees Paid by month"}
                        categories={data2Categories}
                        serieName={"Employees"}
                        tickPositions={[0,50,100,150,200,250,300,350,400]}
                    />
                </Col>
            </Row>

        )
    }
    renderBoxesRow1 = () => {
        let info = this.state.Results
        const MyBox = (label, val, colorText) => {
            return (
                <Col span={4}>
                    <Card
                        title={label}
                        bordered={false}
                        style={{margin:5,minHeight: 100, color: colorText, fontWeight: "bold", fontSize: 9, textAlign: "right"}}
                        headStyle={{color: Colors.brand.dark, fontSize: 10, fontWeight: "bold",textAlign:"center"}}
                    >
                        <span style={styles.myboxAmount}>{val}</span>
                    </Card>
                </Col>
            )
        }
        const toShort = (inValue) => {
            let amount = inValue.toFixed(2)
            return parseFloat(amount)
        }

        return (
            <div style={styles.rowContainer}>
                {MyBox("Not Claimed", FormatMoneySouthAfrica(toShort(info.TotalWagesNotClaimed)), "red")}
                {MyBox("Gross Wages", FormatMoneySouthAfrica(toShort(info.TotalGrossWage)), "black")}
                {MyBox("UIF", FormatMoneySouthAfrica(toShort(info.TotalUif)), "black")}
                {MyBox("PAYE", FormatMoneySouthAfrica(toShort(info.TotalPaye)), "black")}
                {MyBox("Deductions", FormatMoneySouthAfrica(toShort(info.TotalDeduction)), "black")}
                {MyBox("Net Wages", FormatMoneySouthAfrica(toShort(info.TotalNetPay)), "black")}
            </div>
        )
    }
    renderGrossProfitTrend = () => {
        let res = this.state.Results.Breakdown;
        let data =[]// [32.32, 28.65, 36.63, 21.25, 42.36];
        let categories =[] // ["Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22"]
        for(let i in res){
            let row = res[i];
            let revenue = row.Invoices;
            let wages = row.PayrollWages
            let date = moment(row.Month,"YYYY-MM").format("MMM-YY")
            let per = this.calculateTrend(revenue,wages)
            data.push(per)
            categories.push(date)
        }
        let GrossProfitMarginTarget = 25
        return (
            <DashboardPayrollLinePolite
                avgIn={GrossProfitMarginTarget}
                chartId={"dashTrend1"}
                data={data}
                columnColor={["#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50", "#333F50",]}
                titleChart={"Gross Profit Margin Trend"}
                categories={categories}
                tickPositions={[0,5,10,15,20,25,30,35,40,45,50]}
                prefixX={'{text} %'}
            />
        )

    }
    renderSmallSummary=()=>{
        console.log("renderSmallSummary !> ",this.state.Results)
        const res = this.state.Results;

        let priorTotalRevenuePer = 0;
        let priorTotalRevenueAmount = 0;
        let priorTotalRevenueIndicator="down";

        let priorTotalGrossWagePer = 0;
        let priorTotalGrossWageAmount = 0;
        let priorTotalGrossWageIndicator="down";

        let priorTotalGrossProfitPer = 0;
        let priorTotalGrossProfitAmount = 0;
        let priorTotalGrossProfitIndicator="down";

        if(typeof res.PriorTotalRevenuePer !=="undefined"){
            priorTotalRevenuePer = res.PriorTotalRevenuePer
        }
        if(typeof res.PriorTotalRevenueAmount !=="undefined"){
            priorTotalRevenueAmount = res.PriorTotalRevenueAmount
        }
        if(typeof res.PriorTotalRevenueIndicator !=="undefined"){
            priorTotalRevenueIndicator = res.PriorTotalRevenueIndicator
        }
        /**
         * wage
         */
        if(typeof res.PriorTotalGrossWagePer !=="undefined"){
            priorTotalGrossWagePer = res.PriorTotalGrossWagePer
        }
        if(typeof res.PriorTotalGrossWageAmount !=="undefined"){
            priorTotalGrossWageAmount = res.PriorTotalGrossWageAmount
        }
        if(typeof res.PriorTotalGrossWageIndicator !=="undefined"){
            priorTotalGrossWageIndicator = res.PriorTotalGrossWageIndicator
        }
        /**
         * Profit
         */
        if(typeof res.PriorTotalGrossProfitPer !=="undefined"){
            priorTotalGrossProfitPer = res.PriorTotalGrossProfitPer
        }
        if(typeof res.PriorTotalGrossProfitAmount !=="undefined"){
            priorTotalGrossProfitAmount = res.PriorTotalGrossProfitAmount
        }
        if(typeof res.PriorTotalGrossProfitIndicator !=="undefined"){
            priorTotalGrossProfitIndicator= res.PriorTotalGrossProfitIndicator
        }


        return(
            <>
                <Col span={8}>
                    {this.renderMiniCard(
                        "Total Revenue",
                        this.state.Results.TotalRevenue,
                        priorTotalRevenuePer,
                        priorTotalRevenueAmount,
                        priorTotalRevenueIndicator
                    )}
                </Col>
                <Col span={8}>
                    {this.renderMiniCard(
                        "Cost of Goods",
                        this.state.Results.TotalGrossWage,
                        priorTotalGrossWagePer,
                        priorTotalGrossWageAmount,
                        priorTotalGrossWageIndicator
                    )}
                </Col>
                <Col span={8}>
                    {this.renderMiniCard(
                        "Gross Profit",
                        this.state.Results.TotalGrossProfit,
                        priorTotalGrossProfitPer,
                        priorTotalGrossProfitAmount,
                        priorTotalGrossProfitIndicator
                    )}
                </Col>
            </>
        )
    }
    calculateTrend = (totalRevenue, totalCostWages) => {
        let gp = totalRevenue - totalCostWages
        let gpPer = (gp/totalRevenue)*100
        return gpPer
    }

    renderGrossProfitMarginPie = () => {


        let backgroundColor = Colors.brand.light
        let res = this.state.Results;
        let percentage = this.calculateTrend(res.TotalRevenue,res.TotalPayroll)
        if(percentage<25){
            backgroundColor = "red"
        }
        return (
            <div className={"payDashboardPie"}>
                <CircularProgressbar
                    value={percentage}
                    text={`${percentage.toFixed(2)}%`}
                    styles={buildStyles({
                        textSize: '12px',
                        strokeLinecap: 'butt',
                        textColor: 'black',
                        trailColor: 'lightgray',
                        pathColor: backgroundColor,
                    })}
                />
            </div>
        )
    }

    renderMiniCard = (title, amount, percentage, previous, indicator) => {
        return (
            <div style={styles.card2}>
                <label style={styles.card2Title}>{title}</label>
                <label style={styles.card2Amount}>{FormatMoneySouthAfrica(toShort(amount))}</label>
                <label style={{
                    ...styles.card2Percentage,
                    color: indicator === "up" ? "green" : "red"
                }}>{percentage}%</label>
                <label style={styles.card2Previous}>vs prior period R{previous}</label>
            </div>
        )
    }

    render() {
        let props = this.props;
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                    margin: -20,
                    padding: 10,
                }}>
                    {this.state.Results === null ?
                        <>
                            <Title style={styles.title}>Dashboard Payroll Profit</Title>
                            <Row gutter={16} style={{marginTop: 20}}>
                                <Col span={12}>
                                    <Form.Item
                                        label={"Company"}
                                    >
                                        {this.renderCompaniesSelection()}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={"Project"}
                                    >
                                        {this.renderModules()}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16} style={{marginTop: -40}}>
                                <Col span={12}>
                                    <Form.Item
                                        label={"Start Date"}
                                    >
                                        <DatePicker onChange={this.onChangeStartDate} style={{minWidth: "100%"}}/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={"End Date"}
                                    >
                                        <DatePicker onChange={this.onChangeEndDate} style={{minWidth: "100%"}}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16} style={{marginTop: -10}}>
                                <Col span={24}>
                                    <Button style={{minWidth: "100%"}} danger onClick={() => this.submitSearch()}>Search
                                    </Button>&nbsp;&nbsp;
                                </Col>
                            </Row>
                        </> : null}
                    {this.state.Results !== null ?
                        <>
                            <Row>
                                <Col span={24} style={{padding: 0, fontSize: 34, marginTop: -40, marginLeft: 0}}>
                                    <CloseCircleOutlined size={34} onClick={() => this.setState({Results: null})}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={11}>
                                    <Row>
                                        <Col span={8} style={styles.card1Box}>
                                            <span style={styles.card1BoxLabel}>Gross Profit Margin</span>
                                            {this.renderGrossProfitMarginPie()}
                                        </Col>
                                        <Col span={16} style={styles.card1LineChart}>
                                            {this.renderGrossProfitTrend()}
                                        </Col>
                                    </Row>
                                    <Row>
                                        {this.renderSmallSummary()}
                                    </Row>
                                    <Row>
                                        <Col span={24} style={{paddingLeft: 10, paddingRight: 10, marginTop: 10}}>
                                            {this.renderPayrollDesignationSummaryTable()}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={13}>
                                    <Row>
                                        <Col span={24}>
                                            {this.renderPayrollByMonthTable()}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            {this.renderGrossWagePaymentByMonth()}
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop: 10}}>
                                        <Col span={24}>
                                            {this.renderBoxesRow1()}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </> : null
                    }
                </div>
                <LoadingProcessing open={this.state.isLoading}/>
            </Page>
        )
    }
}


export default Connector(DashboardPayrollProfitPage);

const styles = {
    card2Percentage: {
        marginBottom: 20
    },
    card2Previous: {
        fontSize: 8,
    },
    card2Amount: {
        color: "black",
        fontSize: 14,
        fontWeight: "bold",
        marginTop: 20,
        marginBottom: 10,
    },
    card2Title: {
        fontSize: 11,
        color: Colors.brand.dark,
        fontWeight: "bold",
        marginTop: -20
    },
    card2: {
        height: 200,
        minHeight: 200,
        backgroundColor: "white",
        padding: 5,
        margin: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    card1LineChart: {
        width: "98%",
        maxHeight: 290,
        minHeight: 290,
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: 10,
        marginTop: -10,

    },
    card1BoxLabel: {
        color: Colors.brand.dark,
        fontSize: 10,
        fontWeight: "bold",
        marginTop: 10,
    },
    card1Box: {
        width: "100%",
        backgroundColor: "white",
        textAlign: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        maxHeight: 270,
        minHeight: 270,
        paddingTop: 10,
        paddingBottom: 10
    },
    resultContainer: {
        minHeight: "100%",
        width: "100%",
        backgroundColor: "lightgray"
    },
    myboxAmount: {
        fontsize: 18,
        fontweight: "bold"
    },
    myboxLabel: {
        color: "darkblue",
        fontsize: 16
    },
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start"
    },
    myboxContainer: {
        backgroundColor: "white",
        minWidth: 150,
        minHeight: 100,
        display: "flex",
        flexDirection: "columns",
        justifyContent: "center",
        alignItems: "center"
    },
    payCycleButton: {
        color: "red",
        fontSize: 24,
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    payCycleWarningLabel: {
        color: "red",
        fontSize: 24,
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    payCycleSavedLabel: {
        color: "green",
        fontSize: 24,
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    }
}
